import { useSelector } from 'react-redux';
import { GpsType } from '../../../../../global/components/layout/layout-models';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { WhoWillEnrollContentModel } from '../../new-hire-enrollment/models/who-will-enroll-models';
import { ParticipantEnrollmentSettings } from '../models/epi-props';

export function useParticipantWhoWillEnrollContentModel(): WhoWillEnrollContentModel {
    const settings = useSelector<TcsmStates, ParticipantEnrollmentSettings>(state => state.epiProps?.participantEnrollmentSettingsState?.epiContent);

    return {
        ...settings,
        gpsType: GpsType.NEW_PARTICIPANT_WHO_WILL_ENROLL,
        hideBack: true,
        initialSuccessMessage: settings.addParticipantSuccessMessage,
    };
}